export default __webpack_public_path__ + "static/media/61.1b7c294b.svg";